/* global window */

import $ from 'jquery';

import './TestResult.scss';
import template from './TestResult.vhtml';

const currentLanguage = window.siteData.language || 'da';

export default {
	name: 'TestResult',
	template: template,
	props: {
		situation: {
			type: Object,
		},
		housing: {
			type: Object,
		},
		interests: {
			type: Array,
		},
		showCloseButton: {
			type: Boolean,
			default: false,
		}
	},
	data: () => ({
		isLoading: true,
		options: null,
	}),
	methods: {
		close() {
			this.$emit('close');
		},
	},
	created() {
		// Disable scrolling
		$('body').css('overflow', 'hidden');

		getTestOptions()
			.then(options => this.options = options)
			.then(() => this.isLoading = false);
	},
	destroyed: function () {
		// Enable scrolling
		$('body').css('overflow', '');
	},
	computed: {
		headerButtonType() {
			return this.showCloseButton ? 'close' : 'link';
		},
	},
};

/**
 * Gets resumes from WP REST API
 */
function getTestOptions() {
	return $.get(`/wp-json/be/v1/test-options`, { 'lang': currentLanguage, '_': '1.5', });
}